import Repository from './Repository';
import {NutrientSource} from "@/models/NutrientSource/NutrientSource";

export const resource = '/accountActivation';

export default {
  verifyEmail(token: string, packageName?: string, freq?: string, chosenNutrientSource?: NutrientSource) {
    const params = new URLSearchParams({ token });

    if (packageName) {
      params.append('package', packageName);
    }

    if (freq !== null && freq !== undefined) {
      params.append('freq', freq.toString());
    }

    if (chosenNutrientSource !== null && chosenNutrientSource !== undefined) {
      params.append('chosenNutrientSource', chosenNutrientSource.toString());
    }

    // Get base URL from environment
    const baseUrl = process.env.VUE_APP_BASE_DOMAIN || '';
    const apiPath = `${process.env.VUE_APP_BASE_DIRECTORY || ''}${resource}/VerifyEmail`;

    // Instead of returning a promise, directly navigate the browser
    window.location.href = `${baseUrl}${apiPath}?${params.toString()}`;

    return Promise.resolve({ data: { redirecting: true } });
  },
  resendVerificationCode(email: string, shouldSkipFreeTrial: boolean = false) {
    return Repository.post(`${resource}/ResendVerificationCode`, {
      email,
      shouldSkipFreeTrial
    });
  },
  verifyAccountActivationStatus(token: string){
    const params = new URLSearchParams({ token });
    return Repository.get(`${resource}/VerifyAccountActivationStatus?${params}`);
  }
};